// Where the robot's own backend is (Misti_HW Backend, port 8008): the app
// messages come from it (contexts/SocketProvider) and so does Misti's voice for
// them (services/sarvamTtsHandler).
//
// The backend runs on the Pi, and so does the browser showing this face, hence
// 127.0.0.1. For a screen on another device, set REACT_APP_ROBOT_URL, or open
// the page with ?robot=<pi-ip> (port 8008 is assumed).
export function robotUrl() {
	const fromPage = new URLSearchParams(window.location.search).get("robot");
	let url = (fromPage || process.env.REACT_APP_ROBOT_URL || "http://127.0.0.1:8008").replace(/\/+$/, "");
	if (!/^https?:\/\//.test(url)) url = `http://${url}`;
	if (!/:\d+$/.test(url)) url = `${url}:8008`;
	return url;
}
